import { render, staticRenderFns } from "./ProjectModuleView.vue?vue&type=template&id=fe025022&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe025022')) {
      api.createRecord('fe025022', component.options)
    } else {
      api.reload('fe025022', component.options)
    }
    module.hot.accept("./ProjectModuleView.vue?vue&type=template&id=fe025022&", function () {
      api.rerender('fe025022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Projects/ProjectModuleView.vue"
export default component.exports